import { methodService, apiService } from "./postalCodeService";

export const URL = {
  BASE_SEARCH: "/search",
};

export function apiPostalCode(data) {
  return apiService(
    URL.BASE_SEARCH + `/${data?.postalCode}`,
    methodService.GET,
    null,
    null
  );
}
